// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSuccess_root__gQXCR","fillColor":"IconSuccess_fillColor__2DwQ-"};